import React from 'react'
import { object } from 'prop-types'
import { Link } from 'gatsby'

const Footer = ({ secondary }) => (
  <>
    <h4 className="other-opportunities-heading">
      Curious about other opportunities McKinsey has to offer?
    </h4>
    <a
      className="btn btn-secondary btn-fill"
      href="https://www.mckinsey.com/careers/search-jobs"
      target="_blank"
      rel="noopener noreferrer"
    >
      Explore our 500+ job listings
    </a>
    <Link to="/index.html" className="cta link-with-arrow dark-theme take-quiz-cta">
      {secondary !== null ? 'Take the quiz again' : 'Take Our Careers Quiz'}
    </Link>
  </>
)

Footer.propTypes = {
  secondary: object,
}

Footer.defaultProps = {
  secondary: null,
}

export default Footer
